import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import { Provider } from 'mobx-react';
import store from './store';
import { Layout } from './layout/Layout';
var App = /** @class */ (function (_super) {
    tslib_1.__extends(App, _super);
    function App(props) {
        return _super.call(this, props) || this;
    }
    App.prototype.componentWillMount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, store.userStore.verify()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    App.prototype.render = function () {
        return (React.createElement(Provider, { featuresStore: store.featureStore, userStore: store.userStore, taskStore: store.taskStore, preferencesStore: store.preferencesStore, projectStore: store.projectStore, nfcTaskStore: store.nfcTaskStore },
            React.createElement(Layout, null)));
    };
    App = tslib_1.__decorate([
        observer
    ], App);
    return App;
}(React.Component));
export default App;



//////////////////
// WEBPACK FOOTER
// ./src/App.tsx
// module id = 323
// module chunks = 0